export default __webpack_public_path__ + "static/media/hamriyah-free-zone-authority.b1320457.png";